import { createFileRoute } from "@tanstack/react-router"
import { EventsVolunteeringPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/events/volunteering"
)({
  component: () => (
    <AuthorizationGate resource={Resource.EVENT} action={Action.READ}>
      <EventsVolunteeringPage />
    </AuthorizationGate>
  ),
})
